import * as React from 'react';

const InstagramIcon = (props) => (
    <svg width={30} height={30} fill="none" {...props}>
        <circle cx={15} cy={15} r={15} fill="#F30074" />
        <mask
            id="a"
            width={30}
            height={30}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'luminance'
            }}
        >
            <circle cx={15} cy={15} r={15} fill="#fff" />
        </mask>
        <path
            fill="#fff"
            fillRule="evenodd"
            d="M15 8.851c2.003 0 2.24.008 3.03.044.732.033 1.129.156 1.393.258.35.136.6.299.863.561.262.263.425.513.56.863.103.264.226.661.259 1.392.036.791.044 1.028.044 3.031s-.008 2.24-.044 3.03c-.034.732-.156 1.129-.258 1.393-.136.35-.299.6-.561.863a2.324 2.324 0 0 1-.863.56c-.264.103-.661.226-1.392.259-.791.036-1.028.044-3.031.044s-2.24-.008-3.03-.044c-.732-.033-1.129-.156-1.393-.258-.35-.136-.6-.299-.863-.561a2.324 2.324 0 0 1-.56-.863c-.103-.264-.226-.661-.259-1.392-.036-.791-.044-1.028-.044-3.031s.008-2.24.044-3.03c.033-.732.156-1.129.258-1.393.136-.35.299-.6.561-.863.263-.262.513-.425.863-.56.264-.103.661-.226 1.392-.259.791-.036 1.028-.044 3.031-.044ZM15 7.5c-2.037 0-2.292.009-3.092.045-.799.037-1.344.163-1.82.349a3.676 3.676 0 0 0-1.33.865 3.676 3.676 0 0 0-.864 1.328c-.186.477-.312 1.023-.349 1.82-.036.8-.045 1.056-.045 3.093s.009 2.292.045 3.092c.037.799.163 1.344.349 1.82.191.494.448.912.865 1.33.417.416.835.673 1.328.864.477.186 1.022.313 1.82.349.8.036 1.056.045 3.093.045s2.292-.009 3.092-.045c.799-.036 1.344-.163 1.82-.349a3.677 3.677 0 0 0 1.33-.865c.416-.417.673-.835.864-1.328.186-.477.312-1.022.349-1.82.036-.8.045-1.056.045-3.093s-.009-2.292-.045-3.092c-.037-.798-.163-1.344-.349-1.82a3.676 3.676 0 0 0-.865-1.33 3.677 3.677 0 0 0-1.328-.864c-.477-.186-1.023-.312-1.82-.349-.8-.036-1.056-.045-3.093-.045Zm.015 3.66a3.854 3.854 0 1 0 0 7.71 3.854 3.854 0 0 0 0-7.71Zm0 6.357a2.502 2.502 0 1 1 0-5.004 2.502 2.502 0 0 1 0 5.004Zm4.866-6.535a.893.893 0 1 1-1.786 0 .893.893 0 0 1 1.786 0Z"
            clipRule="evenodd"
        />
    </svg>
);

export default InstagramIcon;
